export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Revulist
            </h3>
            <p className="text-gray-400 mb-4">
              Connecting patients with quality healthcare providers. Free listings for medical practices.
            </p>
            <div className="flex items-start mb-4">
              <i className="ri-map-pin-line text-teal-400 text-lg mt-1 mr-2"></i>
              <p className="text-gray-400 text-sm">
                North Brunswick,<br />New Jersey 08902
              </p>
            </div>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* For Users */}
          <div>
            <h4 className="text-white font-semibold mb-4">For Users</h4>
            <ul className="space-y-2">
              <li>
                <a href="/vendors" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Search
                </a>
              </li>
              <li>
                <a href="/about" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  About
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="/pricing" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Package &amp; Pricing
                </a>
              </li>
              <li>
                <a href="/faqs" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  FAQs
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Terms
                </a>
              </li>
            </ul>
          </div>

          {/* For Service Providers */}
          <div>
            <h4 className="text-white font-semibold mb-4">For Service Providers</h4>
            <ul className="space-y-2">
              <li>
                <a href="/auth" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Register
                </a>
              </li>
              <li>
                <a href="/pricing" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Package &amp; Pricing
                </a>
              </li>
              <li>
                <a href="/add-listing" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Add Listing
                </a>
              </li>
              <li>
                <a href="/claim" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Claim Your Listing
                </a>
              </li>
              <li>
                <a href="/ads" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Revulist Ads
                </a>
              </li>
            </ul>
          </div>

          {/* Review */}
          <div>
            <h4 className="text-white font-semibold mb-4">Review</h4>
            <ul className="space-y-2">
              <li>
                <a href="/locations" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Locations
                </a>
              </li>
              <li>
                <a href="/categories" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Categories
                </a>
              </li>
              <li>
                <a href="/vendors" className="hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                  Listings
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2025 Revulist. All rights reserved.
          </p>
          <a
            href="https://www.fiverr.com/agencies/darkstarsoft"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 text-sm transition-colors duration-200 cursor-pointer"
          >
            Powered by DarkStar Soft
          </a>
        </div>
      </div>
    </footer>
  );
}
